var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-list-item",
    {
      class: !_vm.accountBlocked ? "active" : "disabled" + " account-id",
      on: { click: _vm.toggleItem }
    },
    [
      _c("span", { staticClass: "settings__item-text text_large" }, [
        _vm._v(_vm._s(_vm.i18n.set_account_id()))
      ]),
      _vm._v(" "),
      _c("md-icon", { staticClass: "md-icon--half-sized" }, [
        _vm._v("keyboard_arrow_right")
      ]),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          staticClass: "account-id__dialog settings-dialog",
          attrs: { "md-active": _vm.isDialogOpened },
          on: {
            "update:mdActive": function($event) {
              _vm.isDialogOpened = $event
            },
            "update:md-active": function($event) {
              _vm.isDialogOpened = $event
            }
          }
        },
        [
          _c("div", { staticClass: "text_large" }, [
            _vm._v(_vm._s(_vm.i18n.set_your_account_id()))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "settings-dialog__content" }, [
            _c(
              "div",
              { staticClass: "account-id__wrapper" },
              [
                _c("qrcode", {
                  staticClass: "qr-code account-id__qr-code",
                  attrs: { text: _vm.accountId, size: 250, color: "#3f4244" }
                }),
                _vm._v(" "),
                _c("clipboard-field", { attrs: { value: _vm.accountId } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-wrap margin-top" },
            [
              _c(
                "md-button",
                {
                  staticClass: "btn md-primary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.isDialogOpened = !_vm.isDialogOpened
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.i18n.lbl_cancel()))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1095922d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1095922d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/settings/security/Security.AccountId.vue
// module id = TdWB
// module chunks = 1